import { DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwUpdate, VersionEvent } from '@angular/service-worker';
import { NotificationType } from 'app/models/notification-types.const';
import { appConfig } from 'environments/environment';
import { filter } from 'rxjs';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class SwUpdaterService {
  private readonly swUpdate = inject(SwUpdate);
  private readonly destroyRef = inject(DestroyRef);
  private readonly notificationService = inject(NotificationService);
  private hasRegisteredVersionListener = false;

  alertSwUpdate(): void {
    if (!appConfig.production || this.hasRegisteredVersionListener) {
      return;
    }

    this.hasRegisteredVersionListener = true;
    this.swUpdate.versionUpdates
      .pipe(
        filter((event: VersionEvent) => event.type === 'VERSION_READY'),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => {
        this.notificationService.notify(NotificationType.APP_UPDATE_INSTALLED, 50000);
      });
  }
}
